<template>
  <div :key="onlykey">
    <el-form ref="generateForm"
      :disabled="disabled"
      :style="{height:data.config.height}"
      label-suffix=":"
      :size="data.config.size"
      :model="models" :rules="rules" @submit.native.prevent :label-position="data.config.labelPosition" :label-width="data.config.labelWidth + 'px'">
      <template v-for="item in data.list">
        <template v-if="item.type == 'grid'">
          <el-row
            :key="item.key"
            type="flex"
            :gutter="item.options.filter(x => x.attrName == 'gutter')[0].value ? item.options.filter(x => x.attrName == 'gutter')[0].value/1 : 0"
            :justify="item.options.filter(x => x.attrName == 'justify')[0].value"
            :align="item.options.filter(x => x.attrName == 'align')[0].value"
            style="min-height:50px">
            <el-col v-for="(col, colIndex) in item.options.filter(x => x.attrName == 'grid')[0].group" :key="colIndex" :span="col.span">
              <template v-for="citem in col.list" >
                <el-form-item v-if="citem.type=='blank'" :label="citem.name" :prop="citem.model" :key="citem.key">
                  <slot :name="citem.model" :model="models"></slot>
                </el-form-item>

								<dynamic-link v-else-if="citem.type == 'business'"
                  :style="{height:data.config.height}"
                  :key="citem.component"
                  :type="citem.component"
                  :componentname="citem.name"
                  :comData="citem.options|transObj">
                  <template :slot="key" v-for="(val,key) in $slots">
                    <slot :name="key"></slot>
                  </template>
                </dynamic-link>

                <genetate-form-item v-else
                  :key="citem.key"
                  :models.sync="models"
                  :remote="remote"
                  :rules="rules"
                  :widget="citem"
                  @input-change="onInputChange"
                  @on-province-change="onProvinceChange"
                  @on-city-change="onCityChange">
                </genetate-form-item>
              </template>
            </el-col>
          </el-row>
        </template>

        <template v-else-if="item.type == 'blank'">
          <el-form-item :label="item.name" :prop="item.model" :key="item.key">
            <slot :name="item.model" :model="models"></slot>
          </el-form-item>
        </template>

        <template v-else-if="item.type == 'tabs'">
			  	<el-tabs v-model="item.options.filter(x => x.attrName == 'defaultValue')[0].value" :type="item.options.filter(x => x.attrName == 'types')[0].value" :tab-position="item.options.filter(x => x.attrName == 'tabPosition')[0].value" :key="item.name">
				    <el-tab-pane v-for="(titem,colIndex) in item.options.filter(x => x.attrName == 'tabChange')[0].group" :label="titem.label" :name="titem.name" :key="colIndex" >
				    	<template v-for="_item in titem.list">
				    		<dynamic-link v-if="_item.type == 'business'"
                              :type="_item.component"
                              :style="{height:data.config.height}"
                              :componentname="_item.name"
                              :key="_item.component"
                              :comData="_item.options|transObj">
                                <template :slot="key" v-for="(val,key) in $slots">
                                  <slot :name="key"></slot>
                                </template>
                              </dynamic-link>

					    	<genetate-form-item
					    		v-else
	                :key="_item.key"
	                :models.sync="models"
	                :remote="remote"
	                :rules="rules"
	                :widget="_item"
	                @input-change="onInputChange"
                  @on-province-change="onProvinceChange"
                  @on-city-change="onCityChange">
	              </genetate-form-item>
				    	</template>
				    </el-tab-pane>
				  </el-tabs>
				</template>

        <template v-else-if="item.type == 'business'">
					<dynamic-link :style="{height:data.config.height}"
                        :type="item.component"
                        :componentname="item.name"
                        :key="item.component"
                        :comData="item.options|transObj"
                        ref="dynamic">
                          <template :slot="key" v-for="(val,key) in $slots">
                            <slot :name="key"></slot>
                          </template>
                        </dynamic-link>
				</template>

        <template v-else>
          <genetate-form-item
            :key="item.key"
            :models.sync="models"
            :rules="rules"
            :widget="item"
            @input-change="onInputChange"
            @on-province-change="onProvinceChange"
            @on-city-change="onCityChange"
            :style="{height:data.config.height}"
            :remote='remote'>
          </genetate-form-item>
        </template>

      </template>
    </el-form>
  </div>
</template>

<script>
import GenetateFormItem from './GenerateFormItem'
import DynamicLink from '@/components/vueformmaking/DynamicLink'
/**
 *宋建国：2020/2/1 18:05
 *描述：为解决vue过滤器中无法使用this而定义的组件内全局变量
 *版本：1.0
 */
let self = this;
export default {
  name: 'fm-generate-form',
  components: {
    GenetateFormItem
  },
  props:{
    data: {},
    remote: {},
    value: {},
    disabled:false
  },
  data () {
    return {
      models: {},
      rules: {},
      activeName:'first',
      onlykey:0
    }
  },
  created () {
    this.generateModle(this.data.list)
  },
  filters:{
    transObj(val){
      /**
       *宋建国：2020/1/31 12:44
       *描述：转换对象
       *版本：1.0
       */
      function fact(data){
        let _obj = {};
        // 表格初始化时查询条件
        let initobj = {}
        // 外部的注入额外的查询参数
        let custobj = {}
        data.forEach(_item => {
          if(_item.list && _item.list.length > 0){
            _obj[_item.attrName] = fact(_item.list);
          }else if(_item.arrays && _item.arrays.length>0) {
            _obj[_item.attrName] = arrayConvert(_item.arrays);
          }else if(_item.attrName){
            _obj[_item.attrName] = _item.value
          }
        })
        // 如果没有设置排序条件就不传排序到表格中
        if(_obj.sorter && _obj.sorter.length>0){
          _obj.sorter = _obj.sorter.filter(s => s.direction && s.property)
        }
        // 表格初始化时查询条件
        if(_obj.InitQuery && _obj.InitQuery.length>0){
          let arr = []
          arr = _obj.InitQuery.filter(init => init.andor && init.field && init.gx && init.value)
          arr.forEach((q,t) => {
            initobj[t] = {}
            for(let o in q){
              initobj[t][o+t] = q[o]
            }
          })
          _obj.InitQuery = initobj
        }
        // 外部的注入额外的查询参数
        if(_obj.customQuery && _obj.customQuery.length>0){
          let ary = []
          ary = _obj.customQuery.filter(cust => cust.andor && cust.field && cust.gx && cust.value)
          ary.forEach((cu,c) => {
            custobj[(100+c)] = {}
            for(let o in cu){
              custobj[100+c][o+(100+c)] = cu[o]
            }
          })
          _obj.customQuery = custobj
        }
        return _obj;
      }

      /**
       *宋建国：2020/1/31 12:45
       *描述：转换数组
       *版本：1.0
       */
      function arrayConvert(arrays) {
        let _arrays = [];
        let _obj = {}
        for(let i=0; i<arrays.length; i++){
          if(arrays[i].list && arrays[i].list.length > 0){
            _obj[arrays[i].attrName] = fact(arrays[i].list);
          }else if(arrays[i].arrays && arrays[i].arrays.length>0) {
            _obj[arrays[i].attrName] = arrayConvert(arrays[i].arrays);
          }else if(Array.isArray(arrays[i])){
            _arrays.push(fact(arrays[i]));
          }else if(arrays[i].attrName){
            _obj[arrays[i].attrName] = arrays[i].value;
          }
        }
        if(!self.$tu.isObjectBlank(_obj)){
          _arrays.push(_obj);
        }
        return _arrays;
      }

      if(val){
        let obj = {};
        val.forEach(item => {
          if(item.arrays && item.arrays.length>0){
            obj[item.attrName] = arrayConvert(item.arrays)
          }else if(item.list && item.list.length > 0){
            obj[item.attrName] = fact(item.list)
          }else if(item.attrName){
            obj[item.attrName] = item.value
          }
        });
        return obj;
      }
    }
  },
  methods: {
    generateModle (genList) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === 'grid') {
          genList[i].options.filter(x => x.attrName == 'grid')[0].group.forEach(item => {
            this.generateModle(item.list)
          })
        }else if(genList[i].type === 'tabs'){
        	genList[i].options.filter(x => x.attrName == 'tabChange')[0].group.forEach(item => {
            this.generateModle(item.list)
          })
        } else if(genList[i].type != 'business') {
          if (this.value && Object.keys(this.value).indexOf(genList[i].model) >= 0) {
            this.models[genList[i].model] = this.value[genList[i].model]
          } else {
            if (genList[i].type === 'blank') {
              this.$set(this.models, genList[i].model, genList[i].options.defaultType === 'String' ? '' : (genList[i].options.defaultType === 'Object' ? {} : []))
            } else {
              this.models[genList[i].model] = genList[i].options.filter(x => x.attrName == 'defaultValue').length>0?genList[i].options.filter(x => x.attrName == 'defaultValue')[0].value:null
            }
          }
          if (this.rules[genList[i].model]) {
            this.rules[genList[i].model] = [...this.rules[genList[i].model], ...genList[i].rules.map(item => {
              if (item.pattern) {
                return {...item, pattern: eval(item.pattern)}
              } else {
                return {...item}
              }
            })]
          } else {
            if(genList[i].rules){
            	this.rules[genList[i].model] = [...genList[i].rules.map(item => {
            	  if (item.pattern) {
            	    return {...item, pattern: eval(item.pattern)}
            	  } else {
            	    return {...item}
            	  }
            	})]
            }
          }
        }
      }
    },
    getData () {
      return new Promise((resolve, reject) => {
        // console.log('generateFormgenerateForm',this.$refs.generateForm);
        // console.log('generateFormgenerateFormvalidate',this.$refs.generateForm.validate);
        this.$refs.generateForm.validate(valid => {
            // console.log('validate',valid);
          if (valid) {
            resolve(this.models)
          } else {
            reject(new Error('表单数据校验失败').message)
          }
        })
      })
    },
    onInputChange (value, field) {
      this.$emit('on-change', field, value, this.models)
    },
    onProvinceChange (value){
      this.$emit('on-province-change',value)
    },
    onCityChange (value){
      this.$emit('on-city-change',value)
    },
    /* 编辑时更新数据 */
    updateModels(data){
      for(let key in this.models){
        if(this.$tu.isObjectBlank(data)){
          this.models[key] = ''
        }else{
          this.models[key] = data[key]
        }
      }
      this.onlykey++
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.generateModle(val.list)
      }
    },
    value: {
      deep: true,
      handler (val) {
        console.log(JSON.stringify(val))
        this.models = {...this.models, ...val}
      }
    }
  },
  beforeCreate() {
    /**
     *宋建国：2020/2/1 18:03
     *描述：为解决vue过滤器中无法使用this而定义的组件内全局变量，初始化self为this对象
     *版本：1.0
     */
    self = this;
  }
}
</script>

<style lang="scss">
// @import '../styles/cover.scss';
</style>



// WEBPACK FOOTER //
// src/components/vueformmaking/GenerateForm.vue